import { render } from "./CartCard.vue?vue&type=template&id=42d0b32e&scoped=true&ts=true"
import script from "./CartCard.vue?vue&type=script&lang=ts"
export * from "./CartCard.vue?vue&type=script&lang=ts"

import "./CartCard.vue?vue&type=style&index=0&id=42d0b32e&scoped=true&lang=css"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d0b32e"]])

export default __exports__